import { getEvento } from 'api/methods';

import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import { ApiName } from 'enuns/Api';

interface AssembleiaProduto {
  codigo: string;
  idProduto: number;
  titulo: string;
}

interface AssembleiaTipo {
  codigo: string;
  descricao: string;
  id: number;
  titulo: string;
}

type AssembleiaStatusDesc =
  | 'NAO_DISPONIVEL'
  | 'PRE_ASSEMBLEIA'
  | 'ASSEMBLEIA'
  | 'POS_ASSEMBLEIA'
  | 'ENCERRADO';

export interface AssembleiaResponse {
  dataEvento: string;
  dataEventoFim: string;
  descricao: string;
  idAssembleia: number;
  produtos: Array<AssembleiaProduto>;
  status: AssembleiaStatus;
  statusChat: boolean;
  statusDesc: AssembleiaStatusDesc;
  tipoAssembleia: Array<AssembleiaTipo>;
  titulo: string;
  urlTransmissao: string;
}

export default {
  carregar: (idEvento: number) => {
    const endpoint = `assembleia/${idEvento}`;
    return getEvento<AssembleiaResponse>(ApiName.Evento, endpoint);
  },
};
